export default "__VITE_ASSET__326383d1__"